var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 78,
    viewBox: "0 0 74 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 36.5,
    r: 36.5,
    fill: "#9EC3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 26.5C30.4249 26.5 25.5 31.4249 25.5 37.5C25.5 43.5751 30.4249 48.5 36.5 48.5C42.5751 48.5 47.5 43.5751 47.5 37.5V36.8125C47.5 36.0531 48.1156 35.4375 48.875 35.4375C49.6344 35.4375 50.25 36.0531 50.25 36.8125V37.5C50.25 45.0939 44.0939 51.25 36.5 51.25C28.9061 51.25 22.75 45.0939 22.75 37.5C22.75 29.9061 28.9061 23.75 36.5 23.75H37.1875C37.9469 23.75 38.5625 24.3656 38.5625 25.125C38.5625 25.8844 37.9469 26.5 37.1875 26.5H36.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6714 24.8787C44.3941 24.156 45.3743 23.75 46.3964 23.75C47.4184 23.75 48.3986 24.156 49.1213 24.8787C49.844 25.6014 50.25 26.5816 50.25 27.6036C50.25 28.6257 49.844 29.6059 49.1213 30.3286L48.0445 31.4054C47.5075 31.9424 46.6369 31.9424 46.1 31.4054L42.5946 27.9001C42.0576 27.3631 42.0576 26.4925 42.5946 25.9555L43.6714 24.8787ZM40.6501 29.8446C40.1131 29.3076 39.2425 29.3076 38.7055 29.8446L32.5712 35.9789C32.395 36.1552 32.27 36.376 32.2095 36.6177L31.0411 41.2915C30.9239 41.7601 31.0612 42.2557 31.4028 42.5973C31.7443 42.9388 32.2399 43.0761 32.7085 42.9589L37.3823 41.7905C37.6241 41.7301 37.8449 41.605 38.0211 41.4288L44.1554 35.2945C44.6924 34.7575 44.6924 33.8869 44.1554 33.35L40.6501 29.8446Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: 3,
    width: 77,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilButton);
export default __webpack_public_path__ + "static/media/pencil-button.0f326de7.svg";
export { ForwardRef as ReactComponent };